<template lang="pug">
.c-base-thumb(:class="$style.thumb")
  img(:src="src")
</template>

<script>
import BaseUrlProvider from "@/components/BaseUrlProvider.vue";

export default {
  name: "BaseThumb",
  components: {
    BaseUrlProvider
  },
  props: {
    src: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module lang="sass">
.thumb
  +size(110px, 110px)
  margin: 5px
  border-radius: 6px
  overflow: hidden
</style>
